import { render, staticRenderFns } from "./UserRecords.vue?vue&type=template&id=5e377b8b&scoped=true"
import script from "./UserRecords.vue?vue&type=script&lang=js"
export * from "./UserRecords.vue?vue&type=script&lang=js"
import style0 from "./UserRecords.vue?vue&type=style&index=0&id=5e377b8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e377b8b",
  null
  
)

export default component.exports